@import '../../../theme/tokens';

.ay2-accordion-set {

}
